import React from 'react';
import { connect } from 'react-redux';
import { Sidebar, Segment, Button, Menu, Icon, Dropdown } from 'semantic-ui-react';
import InfiniteScroll from 'react-infinite-scroll-component'
import { Link } from 'react-router-dom'
import { ActionCable } from 'react-actioncable-provider';
import 'semantic-ui-css/semantic.min.css';
import moment from 'moment'

import { logOutToken, refreshUser } from '../actions/app_token'
import { createNewPlan, updatePlan, getPlans, loadPlan, openPlanPage, clearPlan,
        getPlansFailure, loadPlanFailure, updatePlanFailure, exportPlanToExcel, 
        getProfile, saveAsNewPlan, createNewPlanSuccess } from '../actions/plan'
import { toggleRisk, toggleAllRisks, clearRisk, updateRiskFailure, createRisk, deleteRisk, updateRiskByLevel, deleteRiskByLevel, switchRisksVisibilityByLevel } from '../actions/risk'
import { clearControl, getUniqueControls } from '../actions/control'
import { clearTags, updateTagsFailure } from '../actions/tags'
import * as libraryControlActions from '../actions/library_control'
import LibraryControlReviewAction from '../actions/library_control_review';
import { getTranslations } from '../actions/language'
import history from '../history'
import { store } from '../store';

import * as constants from '../constants'
import Toastr from '../components/toastr';
import PlanTable from './plan_tables/plan_table'
import PlanControlsTable from './plan_tables/controls_table'
import TemplateUpdateModal from '../components/template_update_alert'
import EditParticipantsModal from '../components/edit_participants_modal'
import RiskProfileTable from '../components/risk_profile_table'
import SignOffModal from '../components/sign_off_modal'
import SavePlanAsModal from '../components/save_plan_as_modal'
import SystemHeader from '../components/system_header'
import Feedback from '../components/feedback'
import ExportModal from '../components/export_modal/index'
import AppComponent from '../components/app_component'
import CreatePlanModal from '../components/create_plan_modal'
import ControlsLink from '../components/controls_link'
import ScopeAndContextModal from '../components/scope_and_context_modal'
import TranslationModal from '../components/translation_modal/translation_modal';
import Chatbot from '../components/chatbot/chatbot';
import { snackbarAddMessage } from '../actions/snackbar';
import LibraryControlReviewModal from './library_control_review/library_control_review_modal'
import PlanChangeLogsModal from './plan_change_logs/plan_change_logs_modal'
import { PlansComparison } from './plans_comparison';
import { FilterByTagsDropdown } from './project_control_register';
import ExportButton from '../components/export_to_excel_button';
import PlanDefaultTemplateControlLogsModal from './plan_default_template_control_logs/plan_default_template_control_logs_modal';

import { isArraysEqual, getText, fetchPlanWithPendingReviews, formatPendingReviews, getLikelihoodOptions } from '../helpers';
import { formatRisk } from '../helpers/risk_helpers';

import Api from '../services/api';

import ObjectITButton from '../components/developed_by_objectit';

import { toolTipManager } from '../services/instanceService';
import ToolTip from '../components/tool_tips/tool_tip';
import { PROJECT_CONTROL_REGISTER_TIP_ID } from '../constants';

import '../App.css';

class PlanView extends AppComponent {
  constructor(props){
    super(props);
    this.page = 1;
    this.searchTerm = '';
    this.sortBy = {
      field: "work_phase_or_ambient_exposure",
      order: "asc"
    };
    this.filterByTags = null;
    this.columnName = '';
    this.hiddenRisksShown = false;
    this.hiddenRiskToggled = false;
    this.exportingPlan = false;
    this.searchIconClass = 'search plus icon';
    this.isControlReport = false;
    this.controlTags = [];

    const uRLSearchParams = new URLSearchParams(this.props.location.search);

    var state = {
      plan: {},
      plans: [],
      risks: [],
      templates: [],
      templateOptions: [],
      pendingReviews: [],
      planId: parseInt(this.props.match.params.plan_id, 10),
      templateId: 1,
      sidebarShown: false,
      templatesModalShown: false,
      plansModalShown: false,
      pendingMessage: "",
      editing: false,
      notifications: "",
      origRisks: [],
      uniqueControls: [],
      searchFieldsShown: false,
      tagOptions: [],
      tagList: [],
      activeTable: 'plan_table',
      pendingReviewsShown: true,
      participantsModalShown: false,
      participants: [],
      origParticipants: [],
      savePlanAsModalShown: false,
      signOffModalShown: false,
      sign_off: [],
      orig_sign_off: [],
      language: this.props.language,
      languages: this.props.languages,
      translations: this.props.language.translations,
      languageName: this.props.language.name,
      exportModal: false,
      createPlanModalShown: false,
      scopeAndContextModalShown: false,
      profileLoading: false,
      uRLSearchParams,
      changeLogs: [],
      planChangeLogsShown : false,
      riskTagsFilter: [],
      controlTagsFilter: [],
      libControlTagsFilter: [],
      libControlAdminsFilter: [],
      businessAreaTagsFilter: [],
      plansComparisonShown: false,
      copyingSuccess: false,
      messageShown: false,
      messageHeader: '',
      messageBody: '',
      messageType: '',
      messageClass: '',
      defaultTemplateControlLogsShown: false,
      hasDefaultTemplateControlLogs: false
    }
    this.state = {...this.state, ...state }

    this.updateType = null
    this.selectedRiskId = null

    this.translateLikelihoodConversionToView = this.props.LanguageService.translateLikelihoodConversionToView.bind(this)
    this.translateRiskRatingDict = this.props.LanguageService.translateRiskRatingDict.bind(this)
    this.translateTagOptions = this.props.LanguageService.translateTagOptions.bind(this)

    this.riskRatingDict = this.translateRiskRatingDict()
    this.likelihoodConversionToView = this.translateLikelihoodConversionToView()
    this.likelihoodOptions = getLikelihoodOptions()
    this.controlTagOptions = this.props.LanguageService.translateControlTagOptions(this.state.translations)

  }

  componentWillMount = () => {
    this.setPermission()
    this.reloadLanguageTranslations()
    if (!this.props.signedIn){
      return history.push(constants.LOGIN_PATH)
    }

  }

  componentDidMount = () => {
    const { uRLSearchParams } = this.state;
    this.searchTerm = uRLSearchParams.get("search_term");
    this.columnName = uRLSearchParams.get("column_name");

    if (uRLSearchParams.get("show_search_fields")) {
      this.setState({ searchFieldsShown: true })
    }

  }

  componentWillReceiveProps = (nextProps) => {
    var translations = nextProps.language.translations
    if (nextProps.language !== this.props.language){
      this.setState({
        language: nextProps.language,
        languages: nextProps.languages,
        translations: nextProps.language.translations,
        languageName: nextProps.language.name,
        tagOptions: [],
      }, ()=>{
        this.likelihoodConversionToView = this.translateLikelihoodConversionToView()
        this.riskRatingDict = this.translateRiskRatingDict()
        this.likelihoodOptions = getLikelihoodOptions()
        this.controlTagOptions = this.props.LanguageService.translateControlTagOptions(this.state.translations)
        this.loadPlan()
        
        const { permission } = this.state;
        if (permission.can_update) this.props.getLibraryControlReviews(this.props.match.params.plan_id);
        if (permission.can_update) this.checkForDefaultTemplateControlLogs();
      })

      if (this.state.activeTable === "risk_profile_table") {
        this.getProfile();
      }
    }

    if(this.hiddenRiskToggled) {
      if(!nextProps.riskPending) {
        this.updateRisksAfterToggle(nextProps.riskResult, nextProps.riskId, nextProps.riskHidden)
      }
      return
    }

    if (nextProps.loadSuccess && this.props.plan.risks !== nextProps.plan.risks) {
      const newRawRisks = nextProps.plan.risks || [];
      const processedNewRisks = newRawRisks.map(risk => formatRisk(risk));

      this.setState(prevState => {
        const currentRiskIds = new Set(prevState.risks.map(risk => risk.id));
        const uniqueNewRisks = processedNewRisks.filter(risk => !currentRiskIds.has(risk.id));
        return {
          plan: nextProps.plan,
          risks: [...prevState.risks, ...uniqueNewRisks],
          pendingReviews: (this.page === 1) ? formatPendingReviews(nextProps.plan.pending_reviews) : prevState.pendingReviews,
          participants: nextProps.plan.participants || [],
          origParticipants: [...(nextProps.plan.participants || [])], //deep clone
          sign_off: nextProps.plan.sign_off || [],
          orig_sign_off: [...(nextProps.plan.sign_off || [])], //deep clone
        };
      });
      this.props.resetLoad();
    }

    if (nextProps.getPlansSuccess && this.props.plans !== nextProps.plans){
      if (nextProps.isTemplate){
        this.setState({
          templates: nextProps.plans,
          templateOptions: this.formatPlans(nextProps.plans),
          templatesModalShown: true
        })
      }
      else {
        this.setState({
          plans: this.formatPlans(nextProps.plans),
          plansModalShown: true
        })
      }
      this.props.resetGetPlans();
    }

    if (nextProps.riskPending || nextProps.updatePending){
      this.setState({
        notifications: "  (" + translations.updating + "...)",
      });
      this.showNotifications(false);
    }

    if (nextProps.createPending){
      this.setState({
        notifications: " (" + translations.creating + "...)",
      });
      this.showNotifications(false);
    }

    if (nextProps.createSuccess){
      this.setState({
        notifications: "",
      });
    }

    if (nextProps.updateRiskSuccess && nextProps.risk !== this.props.risk){
      this.showNotifications(true);

      if(this.updateType === "create") {
        this.createdRisks(this.state.risks, formatRisk(nextProps.risk))
      }
      else if(this.updateType === "delete") {
        // Raw risk passed intentionally - deletedRisk only needs the id, not formatted fields
        this.deletedRisk(this.state.risks, nextProps.risk)
      }
      else {
        const oldRisk = this.state.risks.find(risk => risk.id === nextProps.risk.id) || { tag_list: [] }
        const hasPUE = nextProps.risk.tag_list && nextProps.risk.tag_list.includes("PUE");
        if(!oldRisk.tag_list.includes("PUE") && hasPUE) {
          this.props.snackbarAddMessage({ header: "The risk has been tagged as PUE", content: "The current risk has been automatically tagged as PUE" })
        }
        this.updateRiskArray(formatRisk(nextProps.risk))
      }
      this.selectedRiskId = null
      this.updateType = null
    }

    this.handleUpdateRiskTagsActions(nextProps);

    if(nextProps.updateByLevelPending && nextProps.updateByLevelPending !== this.props.updateByLevelPending) {
      this.setState({
        notifications: " (" + translations.updating + "...)",
      })
      this.showNotifications(false);
    }

    if(nextProps.updateByLevelSuccess) {
      this.showNotifications(true);
      this.updatedRisks(this.state.risks, nextProps.updateByLevelRisks)
    }

    if(nextProps.deleteByLevelPending) {
      this.setState({
        notifications: " (" + translations.deleting + "...)",
      })
      this.showNotifications(false);
    }

    if(nextProps.deleteByLevelSuccess) {
      this.showNotifications(true);
      this.deletedRisks(this.state.risks, nextProps.deleteByLevelRisks)
    }

    if (nextProps.updateSuccess || nextProps.updateControlSuccess || nextProps.deleteControlSuccess || nextProps.updateTagsSuccess || nextProps.createControlSuccess){
      this.setState({
        notifications: "  (" + translations.saved +  ")",
      })
      this.showNotifications(true);
      if (nextProps.updateTagsSuccess) {
        this.props.resetUpdateTags();
      }
      else if (nextProps.updateSuccess ) {
        this.props.resetUpdate();
      }
    }

    if(nextProps.fetchUniqueSuccess) {
      this.setState({
        uniqueControls: nextProps.uniqueControls,
      })
    }

    if(this.exportingPlan && nextProps.exportSuccess) {
      this.exportingPlan = false
      this.saveExportedToExcel(nextProps.exportData)
    }

    this.setState({
      pendingMessage: nextProps.pendingMessage
    })

    this.loadingMessage(nextProps.updatePending || nextProps.createPending || nextProps.loadPending || nextProps.getProfilePending);

    const next_action_type = nextProps.library_control_review.action_type;
    const prev_action_type = this.props.library_control_review.action_type;

    if (prev_action_type === next_action_type) return;

    switch (next_action_type){
      case constants.GET_LIBRARY_CONTROL_REVIEWS.success:
        return this.handleGetLibraryControlReviewsSuccess(nextProps);
      default: return;
    }

  };

  getProfile = () => {
    this.setState({
      profileLoading: true
    }, () => {
      this.props.getProfile(this.state.plan.id);
    })
  }

  handleUpdateRiskTagsActions = (nextProps) => {
    if (this.props.riskActionType === nextProps.riskActionType) return;

    const { translations } = nextProps.language;

    switch (nextProps.riskActionType) {
      case constants.UPDATE_RISK_TAGS.request:
        return this.displayUpdateRiskTagsNotifcations(` (${translations.updating_risk_tags_notifs}...)`);
      case constants.UPDATE_RISK_TAGS.success:
        return this.displayUpdateRiskTagsNotifcations(` (${translations.success_updating_risk_tags_notifs}...)`);
      case constants.UPDATE_RISK_TAGS.failure:
        return this.displayUpdateRiskTagsNotifcations(` (${translations.failure_updating_risk_tags_notifs}...)`);
      default: return;
    };

  }

  displayUpdateRiskTagsNotifcations = (notifications) => {
    this.setState({ notifications });
    this.showNotifications(true, 1500)
  }

  showNotifications = (timed, timeout=3000) => {
    var notifs = document.getElementById("notifications");
    notifs.style.display = "inline";
    if (timed){
      setTimeout(()=>{ notifs.style.display = "none"; }, timeout);
    }
  }

  loadingMessage = (pending) => {
    var messageblock = document.getElementById("loading-message");
    if (pending){
      messageblock.style.display = "block";
    }
    else {
      messageblock.style.display = "none";
    }
  };

  updateRiskArray = (newRisk) => {
    const risks = this.state.risks.map(risk =>
      risk.id === newRisk.id ? newRisk : risk
    );
    this.setState({
      risks,
      notifications: this.state.translations.saved,
    })
    this.props.resetUpdateRisk();
  }

  createdRisks = (risks, new_risk) => {
    const newRisks = [...risks];
    const insertIndex = newRisks.findIndex(risk => risk.id === this.selectedRiskId);
    if (insertIndex > -1) {
      newRisks.splice(insertIndex + 1, 0, new_risk);
    }
    this.setState({
      risks: newRisks,
      notifications: this.state.translations.saved,
    })
    this.props.clearStates()
  }

  getWorkphaseDescription = (risk, language='english') => {
    const language_lower = language.toLowerCase();
    const work_phase_key = language_lower === 'english' ? 'work_phase_or_ambient_exposure' : `work_phase_${language_lower}`;
    return risk[work_phase_key];
  }

  getActivityDescription = (risk, language='english') => {
    const language_lower = language.toLowerCase();
    const activity_key = language_lower === 'english' ? 'activity' : `activity_${language_lower}`;
    return risk[activity_key];
  }

  getHazardDescription = (risk, language='english') => {
    const language_lower = language.toLowerCase();
    const hazard_key = language_lower === 'english' ? 'hazard' : `hazard_${language_lower}`;
    return risk[hazard_key];
  }

  getUnwantedEventDescription = (risk, language='english') => {
    const language_lower = language.toLowerCase();
    const unwanted_event_key = language_lower === 'english' ? 'unwanted_event' : `unwanted_event_${language_lower}`;
    return risk[unwanted_event_key]
  }

  getRiskDescription = (risk, language='english') => {
    const work_phase_desc = this.getWorkphaseDescription(risk, language);
    const activity_desc = this.getActivityDescription(risk, language);
    const hazard_desc = this.getHazardDescription(risk, language);
    const unwanted_event_desc = this.getUnwantedEventDescription(risk, language);
    return `${work_phase_desc} / ${activity_desc} / ${hazard_desc} / ${unwanted_event_desc}`
  }

  dismissMessage = () => {
    this.setState({
      messageShown: false,
      messageHeader: '',
      messageBody: '',
      messageType: '',
      messageClass: ''
    })
  }

  showMessage = (messageState, timeout=6000) => {
    clearTimeout(this.messageTimer);
    this.messageTimer = setTimeout(() => {
      this.dismissMessage();
    }, timeout);

    this.setState(messageState);
  }

  showOutOfScopeMessage = (out_of_scope_descs) => {
    let messageBody = (
      <React.Fragment>
        {
          out_of_scope_descs.map((desc)=>{
            return <div>{desc}</div>
          })
        }
      </React.Fragment>
    )

    this.showMessage({
      messageBody,
      messageShown: true,
      messageType: 'success',
      messageClass: 'out-of-scope-message',
      messageHeader: getText('Marked as Out of Scope')
    })
  }

  updatedRisks = (risks, updated_risks) => {
    const { languageName } = this.state;
    const outOfScopeDescriptions = [];
    const newRisks = [...risks];

    for (const updated_risk of updated_risks) {
      const matchedIndex = newRisks.findIndex((risk) => risk.id === updated_risk.id);

      if (matchedIndex === -1) continue;

      if (updated_risk.hidden) {
        const outOfScopeRisk = newRisks[matchedIndex];
        const description = this.getRiskDescription(outOfScopeRisk, languageName);
        outOfScopeDescriptions.push(description);
        newRisks.splice(matchedIndex, 1);
      } else {
        newRisks[matchedIndex] = formatRisk(updated_risk);
      }
    }

    this.setState({
      risks: newRisks,
      notifications: this.state.translations.saved,
    })
    this.props.clearStates();

    if (outOfScopeDescriptions.length > 0) {
      this.showOutOfScopeMessage(outOfScopeDescriptions);
    }
  }

  deletedRisks = (risks, deleted_risks) => {
    var new_risks = []
    for(var i in risks) {
      var deleted = false

      for(var j in deleted_risks) {
        if(risks[i].id === deleted_risks[j].id) {
          deleted = true
          break
        }
      }

      if(!deleted) {
        new_risks = new_risks.concat(risks[i])
      }
    }

    this.setState({
      risks: new_risks,
      notifications: this.state.translations.saved,
    })
    this.props.clearStates()
  }

  deletedRisk = (risks, deleted_risk) => {
    var new_risks = []

    for(var i in risks) {
      if(deleted_risk.id === risks[i].id) {
        continue
      }
      new_risks = new_risks.concat(risks[i])
    }

    this.setState({
      risks: new_risks,
      notifications: this.state.translations.saved,
    })
    this.props.clearStates()
  }

  formatPlans = (plans) => {
    var new_plans = []
    if (plans.length===0){
      return new_plans
    }

    for (var i in plans){
      var plan = {
        key: plans[i].id,
        value: plans[i].id,
        text: plans[i].name
      }
      new_plans = new_plans.concat(plan)
    }
    return new_plans
  }

  toggleSideBar = () => {
    this.setState({ sidebarShown: true })
  }

  hideSideBar = () => {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  editPlanName = () => {
    var edit_name = document.getElementById("editable-name");
    var static_name = document.getElementById("static-name");
    edit_name.style.display = "inline";
    static_name.style.display = "none";
  }

  updatePlanName = () => {
    this.setState({ editing: false })
    var static_name = document.getElementById("static-name");
    var edit_name = document.getElementById("editable-name");
    edit_name.style.display = "none";
    static_name.style.display = "inline";

    const newPlan = this.removeUnnecessaryKeysFromPlan(this.state.plan);
    this.props.updatePlan(newPlan);
  }

  handleNameChange = (e) => {
    this.setState({ editing: true })
    var plan = {...this.state.plan}
    plan.name = e.target.value
    this.setState({ plan });
  }

  hideTemplatesModal = () => {
    this.setState({
      templatesModalShown: false
    })
  }

  hidePlansModal = () => {
    this.setState({
      plansModalShown: false
    })
  }

  showHiddenRisks = (show) => {
    this.hiddenRisksShown = show
    this.page = 1
    this.setState({
      risks: [],
      tagList: []
    })

    if (this.hiddenRisksShown) {
      this.filterByTags = null
      this.searchTerm = ''
    }

    var options = {
      plan_id: parseInt(this.props.match.params.plan_id, 10),
      include_hidden_risks: this.hiddenRisksShown,
      page: this.page,
      search_term: this.searchTerm,
      sort_by: this.sortBy,
      column_name: this.columnName,
      filter_by_tags: this.filterByTags,
      is_control_report: this.isControlReport,
      control_tags: this.controlTags,
      language: this.state.languageName
    }
    this.props.loadPlan(options);

  }

  riskSelection = (row, isSelect) => {
    this.hiddenRiskToggled = true
    this.props.toggleRisk(this.state.plan.id, row.id, !isSelect)
  }

  riskSelectionAll = (isSelect) => {
    this.hiddenRiskToggled = true
    this.props.toggleAllRisks(this.state.plan.id, !isSelect)
  }

  selectedRisks = () => {
    const risks = this.state.risks
    var selected = []
    for (var i in risks) {
      if(!risks[i]["hidden"]) {
        selected.push(risks[i].id)
      }
    }
    return selected
  }

  updateRisksAfterToggle = (result, riskId, hidden) => {
    this.hiddenRiskToggled = false

    if (!result || riskId == null) {
      return
    }

    const risks = this.state.risks.map(risk => {
      if (riskId !== 'all' && riskId !== risk.id) return risk;
      return { ...risk, hidden };
    });

    this.setState({ risks })
  }

  fetchMoreRisk = () => {
    const { riskTagsFilter, controlTagsFilter, libControlTagsFilter, libControlAdminsFilter, businessAreaTagsFilter } = this.state;
    this.page++

    var options = {
      plan_id: parseInt(this.props.match.params.plan_id, 10),
      include_hidden_risks: this.hiddenRisksShown,
      page: this.page,
      search_term: this.searchTerm,
      sort_by: this.sortBy,
      column_name: this.columnName,
      filter_by_tags: this.filterByTags,
      is_control_report: this.isControlReport,
      control_tags: this.controlTags,
      language: this.state.languageName,
      risk_tags_filter: riskTagsFilter,
      control_tags_filter: controlTagsFilter,
      lib_control_tags_filter: libControlTagsFilter,
      lib_control_admins_filter: libControlAdminsFilter,
      business_area_filter: businessAreaTagsFilter,
    }

    this.props.loadPlan(options);
  };

  loadPlan = () => {
    const { riskTagsFilter, controlTagsFilter, libControlTagsFilter, libControlAdminsFilter, businessAreaTagsFilter } = this.state;
    this.page = 1
    this.setState({
      risks: []
    })

    var options = {
      plan_id: parseInt(this.props.match.params.plan_id, 10),
      include_hidden_risks: this.hiddenRisksShown,
      page: this.page,
      search_term: this.searchTerm,
      sort_by: this.sortBy,
      column_name: this.columnName,
      filter_by_tags: this.filterByTags,
      is_control_report: this.isControlReport,
      control_tags: this.controlTags,
      language: this.state.languageName,
      risk_tags_filter: riskTagsFilter,
      control_tags_filter: controlTagsFilter,
      lib_control_tags_filter: libControlTagsFilter,
      lib_control_admins_filter: libControlAdminsFilter,
      business_area_filter: businessAreaTagsFilter,
    }

    this.props.loadPlan(options);
  }

  setSearchTerm = (searchTerm) => {
    this.searchTerm = searchTerm
  }

  setColumnName = (columnName) => {
    this.columnName = columnName
  }

  setFilterByTags = (filterByTags) => {
    this.filterByTags = filterByTags
  }

  setSortBy = (sortBy) => {
    this.sortBy = sortBy
  }

  renderLoadingMessage = () => {
    return (
      <div id="loading-message">
        <i className="loading circle notched icon plan-loading"></i>
        <span>{this.state.pendingMessage}</span>
      </div>
    )
  }

  toggleExportModal = () => {
    this.setState({
      exportModal: !this.state.exportModal
    })
  }

  exportToFile = (type, columns) => {
    if (type==='Excel') {
      this.exportToExcel(columns);
    }
  }

  exportToExcel = (columns) => {
    const { riskTagsFilter, controlTagsFilter, libControlTagsFilter, libControlAdminsFilter, businessAreaTagsFilter } = this.state;

    if(this.props.exportPending) {
      // already exporting
      return
    }
    this.exportingPlan = true
    var options = {
      plan_id: this.state.plan.id,
      include_hidden_risks: this.hiddenRisksShown,
      search_term: this.searchTerm,
      sort_by: this.sortBy,
      column_name: this.columnName,
      filter_by_tags: this.filterByTags,
      is_control_report: this.isControlReport,
      control_tags: this.controlTags,
      language: this.state.languageName,
      columns: columns,
      risk_tags_filter: riskTagsFilter,
      control_tags_filter: controlTagsFilter,
      lib_control_tags_filter: libControlTagsFilter,
      lib_control_admins_filter: libControlAdminsFilter,
      business_area_filter: businessAreaTagsFilter,
    }
    this.props.exportPlanToExcel(options)
  }

  saveExportedToExcel = (exportData) => {
    var translations = this.state.translations
    var data = exportData.data
    var params = exportData.params
    var tags = ""
    var plan_name = this.state.plan.name.split(' ').map(
      function(value, index) {
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
      }
    ).join('')
    var filename = `${plan_name}.xlsx`
    var search_term = params.search_term

    if(params.is_control_report) {
      var control_tags = params.control_tags
      if(control_tags !== undefined) {
        if(control_tags.length > 0) {
          for(var i in control_tags) {
            tags += control_tags[i]
            if(control_tags.length > (parseInt(i, 10) + 1)) {
              tags += ","
            }
          }
          filename = plan_name + '-' + translations.control_report.replace(' ','') + '(' + tags + ').xlsx'
        }
      }
    }
    else if(params.filter_by_tags) {
      if(search_term && search_term.length > 0) {
        for(var i in search_term) {
          tags += search_term[i]
          if(search_term.length > (parseInt(i, 10) + 1)) {
            tags += ","

          }
        }
        filename = plan_name + '-' + translations.filter_by_tags.replace(' ','') + '(' + tags + ').xlsx'
      }
    }
    else if(search_term && search_term.length > 0) {
      filename = plan_name + '-' + translations.search + '(' + params.search_term + ').xlsx'
    }

    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename.replace('.xlsx', `_${moment(new Date).format("YYYY-MMM-DD")}.xlsx`));
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  toggleSearchState = () => {
    this.searchTerm = '';
    this.filterByTags = null;
    this.columnName = '';
    this.setState({
      tagList: [],
      searchFieldsShown: !this.state.searchFieldsShown
    })
    this.loadPlan();
  }

  handleFilterByTags = (data) => {
    const { 
      riskTagsFilter: newRiskTagsFilter,
      controlTagsFilter: newControlTagsFilter,
      libControlTagsFilter: newLibControlTagsFilter,
      libControlAdminsFilter: newLibControlAdminsFilter,
      businessAreaTagsFilter: newBusinessAreaTagsFilter,
    } = data;

    const { 
      riskTagsFilter,
      controlTagsFilter,
      libControlTagsFilter,
      libControlAdminsFilter,
      businessAreaTagsFilter
    } = this.state;

    const noFilterChanges = isArraysEqual(riskTagsFilter, newRiskTagsFilter) &&
                          isArraysEqual(controlTagsFilter, newControlTagsFilter) && 
                          isArraysEqual(libControlTagsFilter, newLibControlTagsFilter) &&
                          isArraysEqual(libControlAdminsFilter, newLibControlAdminsFilter) &&
                          isArraysEqual(businessAreaTagsFilter, newBusinessAreaTagsFilter);
    
    if (noFilterChanges) return;

    this.setState({
      riskTagsFilter: data.riskTagsFilter,
      controlTagsFilter: data.controlTagsFilter,
      libControlTagsFilter: data.libControlTagsFilter,
      libControlAdminsFilter: data.libControlAdminsFilter,
      businessAreaTagsFilter: data.businessAreaTagsFilter,
      resetFilters: false
    }, ()=>{
      this.columnName = '';
      this.searchTerm = '';
      this.filterByTags = true;
      this.loadPlan();
    })
  }

  handleFilterByTagsFocus = (evt, data) => {
    if (this.state.searchFieldsShown){
      this.setState({ searchFieldsShown: false })
    }
  }

  setTagOptions = (tag) => {
    var found = this.state.tagOptions.some((el) => {
      return el.value === tag.value;
    });
    if (!found) {
      this.state.tagOptions.push(tag);
    }

    this.setState({
      tagOptions: this.state.tagOptions
    })
  }

  resetFilters = () => {
    this.sortBy = {
      field: "work_phase_or_ambient_exposure",
      order: "asc"
    };
    this.searchTerm = '';
    this.filterByTags = null;
    this.columnName = '';
    this.setState({
      tagList: [],
      searchFieldsShown: false,
      riskTagsFilter: [],
      controlTagsFilter: [],
      libControlTagsFilter: [],
      libControlAdminsFilter: [],
      businessAreaTagsFilter: [],
      resetFilters: true
    }, () => this.loadPlan() );
  }

  getControlReport = (control_tags) => {
    this.hiddenRisksShown = false;
    this.sortBy = {
      field: "work_phase_or_ambient_exposure",
      order: "asc"
    };
    this.searchTerm = '';
    this.filterByTags = null;
    this.columnName = '';
    this.isControlReport = true;
    this.controlTags = control_tags;
    this.setState({
      tagList: [],
      searchFieldsShown: false,
      sidebarShown: false,
      activeTable: 'plan_table',
      riskTagsFilter: [],
      controlTagsFilter: [],
      libControlTagsFilter: [],
      libControlAdminsFilter: [],
      businessAreaTagsFilter: [],
      resetFilters: false
    }, () => this.loadPlan() );
  }

  resetControlReport = () => {
    this.isControlReport = false;
    this.controlTags = [];
    this.resetFilters();
  }

  handleReportTagsChange = (evt, object) => {
    this.getControlReport(object.value);
  }

  onTabMenuClick = (activeTable) => {
    if(this.state.activeTable == activeTable) {
      if (this.isControlReport) {
        this.resetControlReport()
      }
      // tab is not changed
      return
    }

    if(this.props.loadPending || this.props.controlPending || this.props.getProfilePending) {
      // data still loading
      return
    }

    this.setState({
      activeTable: activeTable,
      uniqueControls: []
    })

    if(activeTable === 'plan_index_table' && this.state.searchFieldsShown){
      this.toggleSearchState()
    }

    if(activeTable === 'plan_control_table') {
      var options = {
        plan_id: this.state.plan.id,
        include_hidden_risks: false,
        search_term: this.searchTerm,
        sort_by: this.sortBy,
        column_name: this.columnName,
        filter_by_tags: this.filterByTags
      }
      this.props.getUniqueControls(options)
    }
    else if (activeTable === 'risk_profile_table') {
      this.resetControlReport()
      this.getProfile();
    }
    else {
      this.showHiddenRisks(false)
    }
  }

  onCreateRisk = (risk) => {
    this.updateType = "create"
    this.selectedRiskId = risk.selected_risk_id
    this.props.createRisk(this.state.plan.id, risk)
  }

  onUpdateRisks = (value, search_term, column_name, current_risk) => {
    if(column_name.includes('work_phase')) {
      column_name = "work_phase_or_ambient_exposure"
    }
    else if(column_name.includes('activity')) {
      column_name = "activity"
    }
    else if(column_name.includes('hazard')) {
      column_name = "hazard"
    }
    this.props.updateRiskByLevel(this.state.plan.id, value, search_term, column_name, current_risk.work_phase_or_ambient_exposure, current_risk.activity)
  }

  onDelete = (details) => {
    if(details.column === "unwanted_event") {
      this.onDeleteUnwantedEvent(details)
    }
    else {
      var search_term = null

      if (details.column === "work_phase") {
        details.column = "work_phase_or_ambient_exposure"
        search_term = details.work_phase_or_ambient_exposure
      }
      else if (details.column === "activity") {
        search_term = details.activity
      }
      else {
        search_term = details.hazard
      }
      this.onDeleteRisks(search_term, details.column, details.work_phase_or_ambient_exposure, details.activity)
    }
  }

  onDeleteRisks = (search_term, column_name, work_phase, activity) => {
    this.props.deleteRiskByLevel(this.state.plan.id, search_term, column_name, work_phase, activity)
  }

  onDeleteUnwantedEvent = (risk) => {
    this.updateType = "delete"
    this.props.deleteRisk(this.state.plan.id, risk)
  }

  controlReportHeader = () => {
    const { translations } = this.state
    return (
      <Segment basic className="report-header">
        <div className="report-title ui header">{ translations.control_report_for }</div>
        <div className="report-tags">
          <Dropdown
            placeholder={translations.select_tags}
            fluid
            multiple
            search
            selection
            options={ this.controlTagOptions }
            value={ this.controlTags }
            onChange={ this.handleReportTagsChange.bind(this) }
            closeOnBlur={ true }
            closeOnChange={ true }
          />
          <Button className="close-report-div" onClick={()=>this.resetControlReport()}>{translations.close_report}</Button>
        </div>
        <div className='export-button-control-report'>
          <ExportButton
            onClick={this.toggleExportModal}
            loading={this.props.exportPending}
            disabled={this.props.exportPending}
           />
        </div>
      </Segment>
    )
  }

  planTablesTabMenu = (activeTable) => {
    const { translations, resetFilters, pendingReviews, permission, hasDefaultTemplateControlLogs } = this.state;

    const { features } = this.props.instanceConfig;
    const { library_control_reviews } = this.props.library_control_review;
    const isAiChatbotEnabled = features && features.ai_chatbot;
    const isProjectControlsEnabled = features && features.project_controls;
    const isDefaultTemplateControlLogEnabled = features && features.default_template_control_log

    const showLibraryControlReviewsButton = library_control_reviews.length > 0 && permission.can_update;
    const showDefaultTemplateControlLogButton = isDefaultTemplateControlLogEnabled && hasDefaultTemplateControlLogs && permission.can_update;

    const projectControlRegisterTip = toolTipManager.getById(PROJECT_CONTROL_REGISTER_TIP_ID);

    return (
      <Menu>
        { activeTable !== 'risk_profile_table' &&
          <Menu.Item
            name='plan_table'
            active={activeTable === 'plan_table'}
            onClick={(evt)=>this.onTabMenuClick('plan_table')}
          >
            {((this.props.loadPending || this.props.riskPending) && activeTable === 'plan_table') && <i className="loading circle notched icon"></i>} {translations.project_control_register}
          </Menu.Item>
        }
        {!this.hiddenRisksShown && activeTable !== 'risk_profile_table' && <Menu.Item
          name='plan_index_table'
          active={activeTable === 'plan_index_table'}
          onClick={(evt)=>this.onTabMenuClick('plan_index_table')}
        >
          {(this.props.loadPending && activeTable === 'plan_index_table') && <i className="loading circle notched icon"></i>} {translations.index}
        </Menu.Item>}
        {!this.hiddenRisksShown && activeTable !== 'risk_profile_table' && isProjectControlsEnabled && <Menu.Item
          name='plan_control_table'
          active={activeTable === 'plan_control_table'}
          onClick={(evt)=>this.onTabMenuClick('plan_control_table')}
        >
          {this.props.controlPending && activeTable === 'plan_control_table' && <i className="loading circle notched icon"></i>} {translations.controls}
        </Menu.Item>}
        {(activeTable === 'plan_table') && <div className='filter-div '>
          <div className="search-button-div">
            <Button toggle active={this.state.searchFieldsShown} onClick={()=>this.toggleSearchState()}><i className={this.searchIconClass}></i>{translations.search}</Button>
          </div>
          {!this.hiddenRisksShown && <div id="filter-by-tags">
            <FilterByTagsDropdown
              placeholder={translations.filter_by_tags}
              onChange={this.handleFilterByTags}
              onFocus={this.handleFilterByTagsFocus}
              resetFilters={resetFilters}
            />
          </div>}
          {(this.state.searchFieldsShown|| this.filterByTags != null || this.sortBy != null) && <div className="reset-button-div">
            <Button className="reset-button-div" onClick={()=>this.resetFilters()}>{ translations.reset_filters }</Button>
          </div>}
        </div>}
        { activeTable === 'plan_table' && (
          <div className='export-button-plan-table'>
            <ExportButton
              onClick={this.toggleExportModal}
              loading={this.props.exportPending}
              disabled={this.props.exportPending}
            />
          </div>
        )}
        { 
          (activeTable === "plan_table") && 
          <div className="notifications-buttons">
            {
              pendingReviews.length > 0 && permission.can_update &&
              <div className="template-changes-review-button" onClick={ this.togglePendingReviews }>
                <a>{ translations.require_review }</a>
                <sup className="ui red circular label">{pendingReviews.length}</sup>
              </div>
            }
            {
              showLibraryControlReviewsButton &&
              <div className="library-control-reviews-button" onClick={ this.toggleLibraryControlReview }>
                <a>{getText("Library Control Changes")}</a>
                <sup className="ui red circular label">{library_control_reviews.length}</sup>
              </div>
            }
          </div>
        }
        { activeTable === 'risk_profile_table' &&
          <div className="plan-title ui header">{ translations.risk_profile }</div>
        } 
        {
          <div className="plan-change-logs-button" onClick={ this.togglePlanChangeLogs }>
            <a>{getText("Change Logs")}</a>
          </div>
        }        
        {
          showDefaultTemplateControlLogButton &&
          <div className="plan-change-logs-button" onClick={ this.toggleDefaultTemplateControlLogs }>
            <a>{getText("Default Template Control - Change Logs")}</a>
          </div>
        }
        { isAiChatbotEnabled && <Chatbot planId={this.props.plan.id} planUploadStatus={this.props.planUploadStatus} /> }
        { features && features.tool_tips && projectControlRegisterTip && (
          <div className="control-register-tool-tip-wrapper">
            <ToolTip
              title={projectControlRegisterTip.title}
              description={projectControlRegisterTip.description}
              video={projectControlRegisterTip.video_link}
              size='medium'
            />
          </div>
        )}
      </Menu>
    )
  }

  toggleParticipantsModal = () => {
    this.setState({
      participantsModalShown: !this.state.participantsModalShown
    })
  }

  toggleSignOffModal = () => {
    this.setState({
      signOffModalShown: !this.state.signOffModalShown
    })
  }

  toggleSaveAsPlanModal = () => {
    this.setState({
      savePlanAsModalShown: !this.state.savePlanAsModalShown
    })
  }

  updateParticipants = (participants) => {
    this.setState({
      participants: participants
    })

    var plan = {...this.state.plan}
    plan.participants = participants
    this.setState({ plan });

  }

  saveParticipants = () => {
    var plan = {...this.state.plan}
    plan.participants = this.state.participants
    this.setState({
      origParticipants: this.state.participants.map((object) => Object.assign({}, object)),
      plan: plan
    }, ()=>{
      const newPlan = this.removeUnnecessaryKeysFromPlan(this.state.plan);
      this.props.updatePlan(newPlan);
    })
  }

  resetParticipants = () => {
    this.setState({
      participants: this.state.origParticipants.map((object) => Object.assign({}, object))
    })
  }

  updateSignOff = (sign_off) => {
    this.setState({
      sign_off: sign_off
    })

    var plan = {...this.state.plan}
    plan.sign_off = sign_off
    this.setState({ plan });
  }

  saveSignOff = () => {
    const newPlan = this.removeUnnecessaryKeysFromPlan(this.state.plan);
    this.props.updatePlan(newPlan);
    this.setState({
      orig_sign_off: this.state.sign_off.map((object) => Object.assign({}, object))
    })
  }

  resetSignOff = () => {
    this.setState({
      sign_off: this.state.orig_sign_off.map((object) => Object.assign({}, object))
    })
  }

  openScope = (plan) => {
    history.push({
      pathname: constants.PLAN_ACTIVITIES_PATH.replace(":plan_id", plan.id),
      state: { plan: plan }
    })
  }

  openCreatePlanModal = () => {
    const options = { is_template:true }
    this.props.getPlans(options).then(() => {
      if( this.props.plans){
        this.setState({
          templates: this.props.plans,
          templateOptions: this.formatPlans(this.props.plans),
          createPlanModalShown: true,
        })
      }
    })
  }

  onCreatePlan = (templateId, plan, participants) => {
    const newPlanParams = {
      plan_name: plan.name,
      plan_permissions: plan.plan_permissions,
      template_plan_id: templateId,
      participants: participants,
    }
    
    this.props.newPlan(newPlanParams)
    this.setState({ createPlanModalShown: null })
  }

  clonePlanChannelReceived = (received_data) => {
    if (received_data.clone_id === this.state.cloneId){
      store.dispatch(createNewPlanSuccess(received_data.plan));
      store.dispatch(refreshUser(received_data.current_user));

      this.setState({ copyingSuccess: true })
      if (!this.state.isTemplate) {
        this.openScope(received_data.plan)
      }
    }
  }

  saveAsNewPlan = (planName, isTemplate) => {
    const cloneId = moment(new Date).format("YYYYMMDDHHmmss");
    this.setState({
      cloneId: cloneId,
      isTemplate: isTemplate,
      copyingSuccess: false
    })

    const { id, participants } = this.state.plan;
    const options = {
      plan_id: id,
      plan_name: planName,
      clone_id: cloneId,
      participants: participants,
      is_template: isTemplate
    }
    this.props.saveAsNewPlan(options)
  }

  showScopeAndContextModal = () => {
    this.setState({ scopeAndContextModalShown: true });
  }

  hideScopeAndContextModal = () => {
    this.setState({ scopeAndContextModalShown: false });
  }

  saveScopeAndContext = (origPlan) => {
    const newPlan = this.removeUnnecessaryKeysFromPlan(origPlan);
    this.props.updatePlan(newPlan);
    this.hideScopeAndContextModal();
  }

  removeUnnecessaryKeysFromPlan = (origPlan) => {
    const newPlan = {...origPlan};
    delete newPlan.pending_reviews
    delete newPlan.plans
    delete newPlan.risks
    return newPlan
  }

  handleGetLibraryControlReviewsSuccess = (nextProps) => {
    if (nextProps.library_control_review.library_control_reviews.length > 0) {
      this.showLibraryControlReview();
    }
  }

  showLibraryControlReview = () => {
    this.setState({ libraryControlReviewShown: true });
  }

  hideLibraryControlReview = () => {
    this.setState({ libraryControlReviewShown: false });
  }

  toggleLibraryControlReview = () => {
    this.setState({ libraryControlReviewShown: !this.state.libraryControlReviewShown });
  }

  togglePendingReviews = () => {
    this.setState({ pendingReviewsShown: !this.state.pendingReviewsShown })
  }

  togglePlanChangeLogs = () => {
    this.setState({ planChangeLogsShown: !this.state.planChangeLogsShown });
  }

  togglePlansComparison = () => {
    this.setState({ plansComparisonShown: !this.state.plansComparisonShown }, () => {
      if(!this.state.plansComparisonShown) {
        this.loadPlan()
      }
    });
  }

  switchRisksVisibilityByLevel = (outOfScopeDetails) => {
    this.props.switchRisksVisibilityByLevel(outOfScopeDetails);
  }

  toggleDefaultTemplateControlLogs = () => {
    this.setState({ defaultTemplateControlLogsShown: !this.state.defaultTemplateControlLogsShown });
  }

  refreshPendingReviews = () => {
    fetchPlanWithPendingReviews(this.state.planId, (plan) => {
      this.setState({
        pendingReviews: formatPendingReviews(plan.pending_reviews)
      })
    })
  }

  checkForDefaultTemplateControlLogs = () => {
    const { planId } = this.state;
    const api = new Api();
    const params = { params: { per_page: 15, page: 1 } };

    api.get(`/__api/v1/plans/${planId}/default_template_control_logs`, params)
      .then(response => {
        const { status, data } = response;
        if (status === 200 && data.length > 0) {
          this.setState({
            hasDefaultTemplateControlLogs: true,
            defaultTemplateControlLogsShown: true
          })
        }
      })
  }

  refreshUpdatedRisk = (updatedRisk) => {
    const risks = this.state.risks.map(risk =>
      risk.id === updatedRisk.id ? formatRisk(updatedRisk) : risk
    );
    this.setState({ risks });
  }

  render(props) {
    const { sidebarShown, plan, activeTable, participants, translations, profileLoading, uRLSearchParams, scopeAndContextModalShown,
            libraryControlReviewShown,  planChangeLogsShown, plansComparisonShown, messageShown, messageBody, messageType, messageClass, messageHeader,
            pendingReviews, defaultTemplateControlLogsShown } = this.state;
    const createPlanItem = <Menu.Item name='templates' onClick={this.openCreatePlanModal}><span className="sidebar-button-wrap"><Icon name='plus'></Icon><div>{translations.new_plan}</div></span></Menu.Item>
    const selectRow = {
      mode: 'checkbox',
      clickToSelect: false,
      selected: this.selectedRisks(),
      hideSelectColumn: !this.hiddenRisksShown,
      onSelect: this.riskSelection,
      onSelectAll: this.riskSelectionAll
    }
    const { features } = this.props.instanceConfig;
    const isPlansComparisonEnabled = features && features.plans_comparison;
    const isProjectControlsEnabled = features && features.project_controls;
    const hideControlsColumns = activeTable === 'plan_index_table' && !this.isControlReport;

    return (
      <div className="App">
        <Sidebar.Pushable as={Segment} id='plan-segment'>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={sidebarShown}
            icon='labeled'
            vertical
            inverted
            onMouseLeave={() => this.hideSideBar()}
          >
            {
              this.props.isAdmin &&
              <Menu.Item name='home' as={Link} to={constants.DASHBOARD_PATH + '/risk_templates'}>
                <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div> {translations.edit_template}</div></span>
              </Menu.Item>
            }
            { this.props.isAdmin &&
              <CreatePlanModal
                trigger={ createPlanItem }
                shown={ this.state.createPlanModalShown }
                templates={ this.state.templates }
                templateOptions={ this.state.templateOptions }
                onCreatePlan={this.onCreatePlan}
                loading={this.state.planPending}
                onClose={() => this.setState({ createPlanModalShown: null })}
                translations={this.state.translations}
                isAdmin={this.props.isAdmin}
              />
            }
            <EditParticipantsModal
              participants={participants}
              updateParticipants={this.updateParticipants}
              saveParticipants={this.saveParticipants}
              resetParticipants={this.resetParticipants}
              shown={this.state.participantsModalShown}
              onClose={()=>this.toggleParticipantsModal()}
              translations={this.state.translations}
              permission={this.state.permission}
              isAdmin={this.props.isAdmin}
            />
            <SignOffModal
              sign_off={this.state.sign_off}
              shown={this.state.signOffModalShown}
              onUpdate={this.updateSignOff.bind(this)}
              onSave={()=>this.saveSignOff()}
              onReset={()=>this.resetSignOff()}
              onClose={()=>this.toggleSignOffModal()}
              translations={this.state.translations}
              user={this.props.user}
              permission={this.state.permission}
              isAdmin={this.props.isAdmin}
            />
            <SavePlanAsModal
              plan={this.state.plan}
              shown={this.state.savePlanAsModalShown}
              onClose={()=>this.toggleSaveAsPlanModal()}
              saveAsNewPlan={this.saveAsNewPlan}
              loadingState={this.props.createPending}
              translations={this.state.translations}
              copyingSuccess={this.state.copyingSuccess}
            />
            <Menu.Item name='home' as={Link} to={constants.DASHBOARD_PATH + '/risk_plans'}>
              <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div> {translations.open_plan}</div></span>
            </Menu.Item>
            {
              !this.hiddenRisksShown &&
              <Menu.Item onClick={()=>this.openScope(this.state.plan)}>
                <span className="sidebar-button-wrap"><Icon name='eye'></Icon><div> {translations.return_to_scope}</div></span>
              </Menu.Item>
            }
            <Menu.Item className={(activeTable !== 'risk_profile_table' && !this.isControlReport) ? 'selected': ''} name='plan_table' onClick={ (evt)=>this.onTabMenuClick('plan_table') }>
              <span className="sidebar-button-wrap"><Icon name='eye slash alternate'></Icon><div> {translations.goto_project}</div></span>
            </Menu.Item>
            <ExportModal
              type="Excel"
              shown={this.state.exportModal}
              onExport={this.exportToFile}
              pending={this.props.exportPending}
              onClose={()=>this.toggleExportModal()}
              translations={this.state.translations}
              languageName={this.state.languageName}
            />
            <Menu.Item name='plan_context' onClick={ ()=>this.showScopeAndContextModal() }>
              <span className="sidebar-button-wrap"><Icon name=''></Icon><div>Scope & Context</div></span>
            </Menu.Item>
            <Menu.Item name='edit_participants' onClick={ ()=>this.toggleParticipantsModal() }>
              <span className="sidebar-button-wrap"><Icon name=''></Icon><div> {translations.participants_label}</div></span>
            </Menu.Item>
            <Menu.Item name='sign_off' onClick={ ()=>this.toggleSignOffModal() }>
              <span className="sidebar-button-wrap"><Icon name=''></Icon><div> {translations.sign_off}</div></span>
            </Menu.Item>
            {
              this.props.isAdmin &&
              <Menu.Item name='save_plan_as' onClick={ ()=>this.toggleSaveAsPlanModal() }>
                <span className="sidebar-button-wrap"><Icon name=''></Icon><div> {translations.save_as}</div></span>
              </Menu.Item>
            }
            <Menu.Item className={this.isControlReport ? 'selected': ''} name='control_report' onClick={ () => this.getControlReport([]) }>
              <span className="sidebar-button-wrap"><Icon name=''></Icon><div> {translations.control_report}</div></span>
            </Menu.Item>
            <Menu.Item className={(activeTable === 'risk_profile_table') ? 'selected': ''} name='risk_profile' onClick={ (evt)=>this.onTabMenuClick('risk_profile_table') }>
              <span className="sidebar-button-wrap"><Icon name=''></Icon><div> {translations.risk_profile}</div></span>
            </Menu.Item>
            {
              isPlansComparisonEnabled &&
              <Menu.Item name='plans_comparison' onClick={ this.togglePlansComparison }>
                <span className="sidebar-button-wrap"><Icon name=''></Icon><div>Compare Plans</div></span>
              </Menu.Item>
            }
            <ControlsLink plan_name={plan.name}/>
            <Menu.Item name='send_feedback' onClick={()=>{}}>
              <span className="sidebar-button-wrap"><Feedback translations={translations}/></span>
            </Menu.Item>
            <Menu.Item>
              <ObjectITButton />
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic>
              <SystemHeader
                toggleSideBar={this.toggleSideBar}
                editPlanName={this.editPlanName}
                updatePlanName={this.updatePlanName}
                handleNameChange={this.handleNameChange}
                notifications={this.state.notifications}
                planName={plan.name}
                showLogout={true}
                view='table'
                showMenuButton={true}
                showLanguage={true}
                permission={this.state.permission}
                showScopeAndContextModal={this.showScopeAndContextModal}
              />
              { this.isControlReport && this.controlReportHeader()}
              { !this.isControlReport && this.planTablesTabMenu(activeTable)}
              {
                (activeTable === 'plan_table') && 
                <TemplateUpdateModal
                  page={ this.page }
                  shown={ this.state.pendingReviewsShown && (pendingReviews.length > 0) && this.state.permission.can_update }
                  pendingReviews={ pendingReviews }
                  onClose={ () => this.setState({ pendingReviewsShown: false }) }
                  translations={this.state.translations}
                  parentView='Project Control Register'
                  refreshPendingReviews={this.refreshPendingReviews}
                />
              }
              {
                libraryControlReviewShown &&
                <LibraryControlReviewModal 
                  plan_id={this.props.match.params.plan_id}
                  onClose={this.hideLibraryControlReview}
                /> 
              }
              {
                planChangeLogsShown &&
                <PlanChangeLogsModal 
                  plan_id={this.props.match.params.plan_id}
                  onClose={this.togglePlanChangeLogs}
                /> 
              }
              {
                plansComparisonShown &&
                <PlansComparison
                  plan={plan}
                  hidePlansComparison={this.togglePlansComparison}
                />
              }
              {
                defaultTemplateControlLogsShown &&
                <PlanDefaultTemplateControlLogsModal 
                  planId={this.props.match.params.plan_id}
                  onClose={this.toggleDefaultTemplateControlLogs}
                /> 
              }

              {
                ( ['plan_table', 'plan_index_table'].includes(activeTable) || this.isControlReport) &&
                <div className="plan-table">
                  {
                    messageShown &&
                    <Toastr className={messageClass} messageHeader={messageHeader} messageBody={messageBody} messageType={messageType} dismiss={ this.dismissMessage }/> 
                  }
                  <PlanTable
                    risks={ this.state.risks }
                    shouldNotRender={ this.state.sidebarShown || this.state.editing }
                    planId={this.state.plan.id}
                    selectRow={ selectRow }
                    hiddenRisksShown={this.hiddenRisksShown}
                    showHiddenRisks={ (show) => this.showHiddenRisks(show) }
                    setSearchTerm={ this.setSearchTerm.bind(this) }
                    setColumnName={ this.setColumnName.bind(this) }
                    setFilterByTags={ this.setFilterByTags.bind(this) }
                    setSortBy={ this.setSortBy.bind(this) }
                    sortBy={this.sortBy}
                    loadPlan={ this.loadPlan.bind(this) }
                    searchFieldsShown={ this.state.searchFieldsShown }
                    setTagOptions={ this.setTagOptions.bind(this) }
                    createRisk={ this.onCreateRisk }
                    onUpdateRisks={ (value, search_term, column_name, current_risk) => this.onUpdateRisks(value, search_term, column_name, current_risk) }
                    deleteRisks={ this.onDelete }
                    riskRatingDict={this.riskRatingDict}
                    likelihoodOptions={this.likelihoodOptions}
                    TagOptions={this.controlTagOptions}
                    likelihoodConversionToView={this.likelihoodConversionToView}
                    loader={()=>this.renderLoadingMessage()}
                    fetchMoreRisk={this.fetchMoreRisk}
                    permission={this.state.permission}
                    hiddenControls={hideControlsColumns}
                    uRLSearchParams={uRLSearchParams}
                    switchRisksVisibilityByLevel={this.switchRisksVisibilityByLevel}
                    refreshUpdatedRisk={this.refreshUpdatedRisk}
                  />
                </div>
              }

              {(activeTable === 'plan_control_table' && !this.isControlReport) && isProjectControlsEnabled && <div className="plan-control-table">
                <InfiniteScroll
                  dataLength={this.state.uniqueControls.length}
                  hasMore={true}
                  loader={this.renderLoadingMessage()}
                  scrollableTarget='plan-segment'
                  endMessage={
                    <p style={{ textAlign: 'center' }}>
                      <b>{translations.end_of_records}</b>
                    </p>
                  }
                >
                  <PlanControlsTable
                    controls = { this.state.uniqueControls }
                    shouldNotRender={ this.state.sidebarShown || this.state.editing }
                    planId={this.state.plan.id}
                    selectRow={ selectRow }
                    hiddenRisksShown={this.hiddenRisksShown}
                    translations={this.state.translations}
                  />
                </InfiniteScroll>
              </div>}

              {(activeTable === 'risk_profile_table' && !this.isControlReport) && <div className="risk-profile-table">
                {
                  profileLoading &&
                  <div id="loading-message" style={{width: "100%"}}>
                    <i className="loading circle notched icon plan-loading"></i>
                    <span>Loading Risk Profile</span>
                  </div>
                }
                { this.props.profile && this.props.profile.profiles && this.props.profile.profiles.length > 0  &&
                  <RiskProfileTable
                    profile={this.props.profile}
                    translations={this.state.translations}
                    riskRatingDict={this.riskRatingDict}
                    likelihoodConversionToView={this.likelihoodConversionToView}
                  />
                }
              </div>}

              {
                scopeAndContextModalShown &&
                <ScopeAndContextModal
                  plan={this.props.plan}
                  hideScopeAndContextModal={this.hideScopeAndContextModal}
                  saveScopeAndContext={this.saveScopeAndContext}
                  permission={this.state.permission}
                />
              }
              {
                this.props.library_control.isTranslationModalShown &&
                <TranslationModal
                  translation_id={this.props.library_control.translation_id}
                  onClose={this.props.hideTranslationModal}
                />
              }
              <ActionCable ref='clonePlanChannel' channel={{channel: 'ClonePlanChannel'}} onReceived={this.clonePlanChannelReceived} />
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //TODO: For improvement, return the whole state instead of separate assignments.
  //Peer review comment: https://gitlab.com/objectit/anglo-debeers-wrac/-/merge_requests/48#note_1317987541
  return {
    token: state.app_token.accessToken,
    signedIn: state.app_token.signedIn,
    user: state.app_token.user,
    plan: state.plan.plan,
    plans: state.plan.plans,
    pendingMessage: state.plan.pendingMessage,
    createSuccess: state.plan.createSuccess,
    createPending: state.plan.createPending,
    loadSuccess: state.plan.loadSuccess,
    loadPending: state.plan.loadPending,
    updateSuccess: state.plan.updateSuccess,
    updatePending: state.plan.updatePending,
    getPlansSuccess: state.plan.getPlansSuccess,
    getPlansPending: state.plan.getPlansPending,
    isTemplate: state.plan.isTemplate,
    exportPending: state.plan.exportPending,
    exportSuccess: state.plan.exportSuccess,
    exportData: state.plan.exportData,
    riskPending: state.risk.pending,
    riskMessage: state.risk.message,
    riskResult: state.risk.result,
    riskId: state.risk.id,
    riskHidden: state.risk.hidden,
    updateRiskSuccess: state.risk.updateSuccess,
    riskCellValue: state.risk.cellValue,
    riskRow: state.risk.row,
    risk: state.risk.risk,
    riskActionType: state.risk.action_type,
    updateByLevelPending: state.risk.updateByLevelPending,
    updateByLevelSuccess: state.risk.updateByLevelSuccess,
    updateByLevelRisks: state.risk.updateByLevelRisks,
    deleteByLevelPending: state.risk.deleteByLevelPending,
    deleteByLevelSuccess: state.risk.deleteByLevelSuccess,
    deleteByLevelRisks: state.risk.deleteByLevelRisks,
    createControlSuccess: state.control.createSuccess,
    updateControlSuccess: state.control.updateSuccess,
    deleteControlSuccess: state.control.deleteSuccess,
    fetchUniqueSuccess: state.control.fetchUniqueSuccess,
    uniqueControls: state.control.uniqueControls,
    controlPending: state.control.pending,
    changeLogs: state.plan.changeLogs,
    updateTagsSuccess: state.tags.updateSuccess,
    getProfilePending: state.plan.getProfilePending,
    getProfileSuccess: state.plan.getProfileSuccess,
    profile: state.plan.profile,
    language: state.language.language,
    languages: state.language.languages,
    user: state.app_token.user,
    isAdmin: state.app_token.isAdmin,
    instanceConfig: state.instance.instanceConfig,
    library_control_review: state.library_control_review,
    library_control: state.library_control,
    planUploadStatus: state.plan.planUploadStatus,
  }
}

const mapDispatchToProps = (dispatch) => {
  const libraryControlReviewAction = new LibraryControlReviewAction();

  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    newPlan: (template_plan_id, plan_name, participants) => {
      dispatch(createNewPlan(template_plan_id, plan_name, participants ))
    },
    updatePlan: (plan) => {
      dispatch(updatePlan(plan))
    },
    loadPlan: (options) => {
      dispatch(loadPlan(options))
    },
    getPlans: (options) => dispatch(getPlans(options)),
    openPlanPage: (plan_id) => {
      openPlanPage(plan_id);
    },
    toggleRisk: (plan_id, risk_id, hidden) => {
      dispatch(toggleRisk(plan_id, risk_id, hidden))
    },
    toggleAllRisks: (plan_id, hidden) => {
      dispatch(toggleAllRisks(plan_id, hidden))
    },
    createRisk: (plan_id, risk) => {
      dispatch(createRisk(plan_id, risk))
    },
    updateRiskByLevel: (plan_id, new_value, search_term, column_name, work_phase, activity) => {
      dispatch(updateRiskByLevel(plan_id, new_value, search_term, column_name, "false", work_phase, activity))
    },
    deleteRisk: (plan_id, risk) => {
      dispatch(deleteRisk(plan_id, risk))
    },
    deleteRiskByLevel: (plan_id, search_term, column_name, work_phase, activity) => {
      dispatch(deleteRiskByLevel(plan_id, search_term, column_name, "false", work_phase, activity))
    },
    resetGetPlans: () => {
      dispatch(getPlansFailure());
    },
    resetLoad: () => {
      dispatch(loadPlanFailure());
    },
    resetUpdateRisk: () => {
      dispatch(updateRiskFailure());
    },
    resetUpdateTags: () => {
      dispatch(updateTagsFailure());
    },
    resetUpdate: () => {
      dispatch(updatePlanFailure());
    },
    clearStates: () => {
      dispatch(clearPlan());
      dispatch(clearRisk());
      dispatch(clearControl());
      dispatch(clearTags());
    },
    getUniqueControls: (options) => {
      dispatch(getUniqueControls(options))
    },
    exportPlanToExcel: (options) => {
      dispatch(exportPlanToExcel(options))
    },
    getProfile: (plan_id) => {
      dispatch(getProfile(plan_id))
    },
    saveAsNewPlan: (options) => {
      dispatch(saveAsNewPlan(options))
    },
    getTranslations: (name) => {
      dispatch(getTranslations(name))
    },
    getLibraryControlReviews: (plan_id) => {
      dispatch(libraryControlReviewAction.getLibraryControlReviews(plan_id))
    },
    hideTranslationModal: () => {
      dispatch(libraryControlActions.hideTranslationModal())
    },
    switchRisksVisibilityByLevel: (params) => {
      dispatch(switchRisksVisibilityByLevel(params))
    },
    snackbarAddMessage: (message) => {
      dispatch(snackbarAddMessage(message))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanView);


// WEBPACK FOOTER //
// ./src/views/plan.js